import { makeStyles } from 'tss-react/mui';
import { theme } from '../../theme';

/**
 * Custom hook that defines the styles for the question page component.
 */
const useQuestionPageStyles = makeStyles()(() => ({
  btns: {
    marginRight: '15%',
  },
  noQuestions: {
    fontSize: theme.fontSize.h6,
    marginLeft: theme.margin.l,
    marginBottom: theme.margin.m,
    marginTop: theme.margin.m,
  },
}));

export default useQuestionPageStyles;
